import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Label,
} from "recharts";
import styled from "styled-components";
import BarGraph from "../../Common/BarGraph/BarGraph";

const Button = styled.button`
  cursor: pointer;
  border-radius: 6px;
  border: 1px solid #a2a2a2;

  background: ${(props) => (props.selected ? props?.is_custom : '#ffff')};

      width: ${(props) => props?.incres == true ? '107px' : '107px'};
    height: 34px;
  color: ${(props) => (props.selected ? '#ffff' : '#292A2A')};
  font-family: inherit;
  font-weight: 600;
  font-style: Semi Bold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  text-transform: capitalize;
`;

const MainDiv = styled.div`
    min-height: 230px;
    display: flex;
    align-items: center;
    max-height: 265px;
    overflow-y: auto;
    margin-left:20px;
`;


const data = [
  { channel: "Flipkart", alerts: 2 },
  { channel: "Instagram", alerts: 2 },
  { channel: "Facebook", alerts: 1 },
  { channel: "Twitter", alerts: 1 },
];

const AlertCountChart = ({personalDetailsData}) => {
  const { configureAlert } = useSelector((state) => state.alert)

  const [selectedButton, setSelectedButton] = useState('twitter');
  const capitalize = (str = "") =>
  str.charAt(0).toUpperCase() + str.slice(1);


  const data = useMemo(() => {
    if (!configureAlert?.channel_data) return [];

    return configureAlert?.channel_data
      ?.filter((i) => i.channel_name === selectedButton)
      ?.map((item) => ({
        name: capitalize(item?.alert_name),          // label
        value: item?.triggered_count,    // number
        fill: "rgba(45, 137, 85, 1)",                 // bar color
      }));
  }, [configureAlert?.channel_data, selectedButton]);


  const handleButtonClick = (val) => {
    setSelectedButton(val)

  }
  console.log(configureAlert, data, "configureAlert");

  return (
    <div style={{ width: "100%", minHeight: 345 }}>
      <h3 style={{
        margin: "0px", marginTop: "20px", fontSize: '15px', fontWeight: '500',
        display: 'flex',
        marginLeft: '18px',
        marginBottom: '12px'
      }}>
        Alert Per Topic
      </h3>
      <div style={{ display: 'flex', marginLeft: '18px' }}>
        <Button
          incres={false}
          is_custom={personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'linear-gradient(95.02deg, #A0D925 -65.35%, #006A68 100%)'}
          style={{ borderRadius: '6px 0px 0px 6px' }}
          selected={selectedButton === 'twitter'}
          onClick={() => handleButtonClick('twitter')}
          
        >
          X
        </Button>
        <Button
          incres={true}
          is_custom={personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'linear-gradient(95.02deg, #A0D925 -65.35%, #006A68 100%)'}
          style={{ borderRadius: '0px 6px 6px 0px' }}
          selected={selectedButton === 'instagram'}
          onClick={() => handleButtonClick('instagram')}
        >
          Instagram
        </Button>
      </div>
      <MainDiv>
        <BarGraph
          is_alert={true}
          data={data}
          type={''}
          isSmall
          borderRadius={'3px 0px 0px 3px'}
          barHeight={'35px'}
          view={'horizontal'}
          showDrillThrough={true}
          job_id={''}
        // handleTabClick={(data) => handleTabClick(data)}
        />
      </MainDiv>
    </div>
  );
};

export default AlertCountChart;
